export const BASE_URL = process.env.EXPO_PUBLIC_BASE_URL || "http://localhost:3000";
//export const BASE_URL = "https://eventlista.no"
export const API_URL = BASE_URL + "/api/v1"
